import React from "react"
import propTypes from "prop-types"
import "./styles.scss"

import InfoCardDescription from "./components/Description"
import InfoCardEdit from "./components/Edit"
import InfoCardItem from "./components/Item"
import InfoCardLabel from "./components/Label"
import InfoCardSubtitle from "./components/Subtitle"
import InfoCardTitle from "./components/Title"
import InfoCardForm from "./components/Form"
import InfoCardFile from "./components/File"

const InfoCard = ({ children, className, onDelete, hideDelete }) => {
  return (
    <div className={["info-card", className].join(" ")}>
      <div className="info-card_inner">
        {children}

        {!hideDelete && (
          <a
            href="/#"
            onClick={e => {
              e.preventDefault()
              onDelete()
            }}
            className="info-card_delete"
          >
            Delete
          </a>
        )}
      </div>
    </div>
  )
}

InfoCard.propTypes = {
  children: propTypes.oneOfType([propTypes.node, propTypes.string]).isRequired,
  className: propTypes.string,
  onDelete: propTypes.func,
  hideDelete: propTypes.bool
}

InfoCard.defaultProps = {
  className: "info-card--white",
  onDelete: () => {},
  hideDelete: false
}

export {
  InfoCardDescription,
  InfoCardEdit,
  InfoCardItem,
  InfoCardLabel,
  InfoCardSubtitle,
  InfoCardTitle,
  InfoCardForm,
  InfoCardFile
}

export default InfoCard
